var speed = 0.2;

$(function(){
    /**
    * Gère le smooth scrolling sur tous les éléments avec la classe "scroll" ayant un attribut "data-scrollto" valide
    */
    $('.scroll').on('click', function(e){
        e.preventDefault();

        var $this = $(this);
        var targetName = $this.attr('data-scrollto');

        // cas où la cible est vide ou pas renseignée
        if(targetName === '' || targetName == null){
            targetName = 'html';
        }

        var $target = $(targetName);
        var targetPosY = $target.offset().top - $menu.height();

        if($(window).width() < 736) $menuContainer.css({ 'display' : 'none' });
        $('html, body').animate({ 'scrollTop' : targetPosY }, 900, 'swing');
    });

    /**
    * Parallaxe
    */
    $(window).scroll(function(e){
        var pos = $(window).scrollTop();
        var height = $('#anchor-parallaxe').height();
        $('#anchor-parallaxe').css('background-position', '50% ' + Math.round((height - pos) * speed) + 'px');
    });
});
